<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Personal information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="Personal information"></el-step>
                  <el-step title="Authentication"></el-step>
                  <el-step title="Bank information"></el-step>
                  <el-step title="Additional information"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-10 col-lg-10"
              style="margin-left: 10%; margin-top: 40px"
            >
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-row>
                  <el-col :span="24">
                    <el-row>
                      <el-col :span="20">
                        <el-row>
                          <el-col :span="8">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Beneficiary Name"
                                  prop="bankacc_name"
                                >
                                  <el-input
                                    v-model="formData.bankacc_name"
                                    placeholder="Must match your name, overseas bank in English or Pinyin"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="8">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="The country of the bank"
                                  prop="bank_area"
                                >
                                  <el-input
                                    v-model="formData.bank_area"
                                    placeholder="Please enter the country of the bank"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="8">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank Account Number or IBAN"
                                  prop="iban"
                                >
                                  <el-input
                                    v-model="formData.iban"
                                    placeholder="Please enter bank IBAN"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>

                      <el-col :span="20">
                        <el-row>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank name"
                                  prop="bank_name"
                                >
                                  <el-input
                                    v-model="formData.bank_name"
                                    placeholder="Please enter the bank name"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank branch name"
                                  prop="bank_branch"
                                >
                                  <el-input
                                    v-model="formData.bank_branch"
                                    placeholder="Japan is required, ignored by other countries"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="20">
                        <el-row>
                          <el-form-item
                            label="The payee's address"
                            prop="bankacc_addr"
                          >
                            <el-input
                              v-model="formData.bankacc_addr"
                              placeholder="Please enter the payee's address"
                              clearable
                              :style="{ width: '100%' }"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="Bank address" prop="bank_addr">
                            <el-input
                              v-model="formData.bank_addr"
                              placeholder="Please enter your bank address"
                              clearable
                              :style="{ width: '100%' }"
                            ></el-input>
                          </el-form-item>
                        </el-row>
                      </el-col>

                      <el-col :span="20">
                        <el-row>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank Wire Transfer Number (SWIFT)"
                                  prop="swift"
                                >
                                  <el-input
                                    v-model="formData.swift"
                                    placeholder="Please enter your bank wire transfer number (SWIFT)"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Routing Number"
                                  prop="routing_no"
                                >
                                  <el-input
                                    v-model="formData.routing_no"
                                    placeholder="Banks in the United States are required and ignored by other countries"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="Select a photo of the Proof of bank"
                        label-width="0"
                        prop="bank_provefile"
                      >
                        <FileUpload
                          emitaction="setbankprovefile"
                          :fileurl="formData.bank_provefile"
                          v-on:emitaction="setbankprovefile"
                        ></FileUpload>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="Proof of bank account number:">
                      <p>You have two options:</p>
                      <p>
                        1. Provide near 1 month bank statement (Bank State,
                        usually downloaded directly from online banking as a PDF
                        file). The statement contains the applicant's name,
                        address, and account number.
                      </p>
                      <p>
                        2. Provide clear screenshots of online banking. The
                        screenshot clearly shows the name of the bank, the name
                        of the account owner (which must match the applicant's
                        name), and the account number to prove the authenticity
                        and accuracy of the bank information.
                      </p>
                    </el-form-item>
                    <!-- <el-form-item label="银行账号证明：">
                      <p>您有两个选择：</p>
                      <p>
                        1. 提供近
                        1个月银行对账单（BankStatement，通常可以直接从网上银行下载为PDF文件）。对账单中包含有申请人姓名、地址和账号。
                      </p>
                      <p>
                        2.提供网上银行清晰截屏。截屏中清晰显示银行名称，账户所有人名称（必须与申请人姓名一致），以及账号，以证明银行信息的真实性与准确性。
                      </p>
                    </el-form-item> -->
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 40px">
                  <el-col :span="6" :offset="0"
                    ><el-button @click="goback">Previous</el-button></el-col
                  >
                  <el-col :span="10" :offset="2">
                    <el-form-item size="large">
                      <el-button type="primary" @click="submitForm"
                        >Submit</el-button
                      >
                      <el-button @click="resetForm">Reset</el-button>
                    </el-form-item></el-col
                  >
                </el-row>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import FileUpload from "../../components/plugins/FileUpload2.vue";
import {
  otc_auth_status,
  get_bank_account,
  att_bank_account,
} from "../../plugins/api/account_otc";
export default {
  components: { FileUpload },
  props: [],
  data() {
    return {
      activeStep: 2,
      formData: {
        bankacc_no: undefined,
        bankacc_addr: undefined,
        bank_name: undefined,
        bank_addr: undefined,
        bank_area: undefined,
        bankacc_name: undefined,
        iban: undefined,
        swift: undefined,
        routing_no: undefined,
      },
      rules: {
        bankacc_no: [
          {
            required: true,
            message: "Please enter your bank account number",
            trigger: "blur",
          },
        ],
        bankacc_addr: [
          {
            required: true,
            message: "Please enter the payee's address",
            trigger: "blur",
          },
        ],
        bank_name: [
          {
            required: true,
            message: "Please enter the bank name",
            trigger: "blur",
          },
        ],
        bank_addr: [
          {
            required: true,
            message: "Please enter your bank address",
            trigger: "blur",
          },
        ],
        // bank_provefile: [
        //   {
        //     required: true,
        //     message: "Bank prove file is required",
        //     trigger: "blur",
        //   },
        // ],
        bank_area: [
          {
            required: true,
            message: "Please enter the location of the bank",
            trigger: "blur",
          },
        ],
        bankacc_name: [
          {
            required: true,
            message: "Must match your name, overseas bank in English or Pinyin",
            trigger: "blur",
          },
        ],
        iban: [
          {
            required: true,
            message: "Please enter your bank account number or IBAN",
            trigger: "blur",
          },
        ],
        swift: [
          {
            required: true,
            message: "Please enter your bank wire transfer number (SWIFT)",
            trigger: "blur",
          },
        ],
        routing_no: [],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      console.log(res);
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_bank_account().then((res_query) => {
      if (res_query.data.bankacc_no) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
      }
    });
  },
  mounted() {},
  methods: {
    setbankprovefile(url) {
      this.formData.bank_provefile = url;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        att_bank_account(this.formData).then((res) => {
          if (res.code == 0 || res.code == 18289475) {
            this.$router.push("/reg/person/step4");
          } else {
          }
        });
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    field136BeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    field137BeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    field138BeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    goback() {
      this.$router.push("/reg/person/step2");
    },
  },
};
</script>
<style>
.el-upload__tip {
  line-height: 1.2;
}
</style>
